import React, { FC } from 'react';

import DangerouslySetInnerHtml from 'layout/DangerouslySetInnerHtml';

import { SoBannerItem, SobannerProps } from '../../models';
import {
  ArticleVariant,
  CardVariant,
  ImageVariant,
  ProductVariant,
  RecipeVariant,
  TextRightVariant,
  TextVariant,
  VideoVariant,
} from '../items';

const ArticleContainerVariant: FC<SobannerProps> = ({
  data: { title, subtitle, extraClass, containerText, items, legalText },
}) => (
  <div className={`soBanner soBanner__container soBanner__container--grid ${extraClass || ''}`}>
    {title ? <h2 className="soBanner__title">{title}</h2> : <></>}

    {subtitle ? <h3 className="soBanner__subtitle">{subtitle}</h3> : <></>}

    <div className="article">
      {items.map((item: SoBannerItem, index: number) => {
        const { variant } = item;
        switch (variant[0]) {
          case 'text':
            return <TextVariant data={item} index={index} />;
          case 'textRight':
            return <TextRightVariant data={item} index={index} />;
          case 'product':
            return <ProductVariant data={item} index={index} />;
          case 'recipe':
            return <RecipeVariant data={item} index={index} />;
          case 'image':
            return <ImageVariant data={item} index={index} />;
          case 'card':
            return <CardVariant data={item} index={index} />;
          case 'video':
            return <VideoVariant data={item} index={index} />;
          case 'article':
            return <ArticleVariant data={item} index={index} />;
          default:
            return <>{variant}</>;
        }
      })}
    </div>
    {containerText ? (
      <DangerouslySetInnerHtml className="grid__text" html={containerText as string} />
    ) : (
      <></>
    )}
    {legalText ? (
      <div className="soBanner__legal-text text-center small">
        <DangerouslySetInnerHtml html={legalText as string} />
      </div>
    ) : (
      <></>
    )}
  </div>
);

export default ArticleContainerVariant;
